import { getValidDate } from 'lib/utils'

export const financeTableTypes = [
  { label: 'Просроченные транши', code: 'overdueTranches' },
  { label: 'График погашения', code: 'paymentSchedule' },
  { label: 'Платежи', code: 'payments' },
  { label: 'Детальная раскладка по операциям', code: 'detailedLayout' },
  { label: 'Периодические реквизиты', code: 'periodicDetails' }
]

export const geFinanceData = contract => {
  return [
    {
      label: 'Основной долг',
      value: `${contract?.principalOutstandingAmount?.toString()?.thousandSeparator() || 0} ₸`
    },
    { label: 'Кредитный продукт', value: contract?.creditProductName || '-' },
    { label: 'Сумма займа', value: `${contract?.loanAmount?.toString()?.thousandSeparator() || 0} ₸` },
    { label: 'Подразделение', value: contract?.subdivisionName || '-' },
    { label: 'Дата выдачи', value: getValidDate(contract?.issueDate) },
    { label: 'Процент', value: `${contract?.interestOutstandingAmount?.toString()?.thousandSeparator() || 0} ₸` },
    { label: 'Дата закрытия', value: getValidDate(contract?.closeDate) },
    { label: 'Дата окончания отсрочки', value: getValidDate(contract?.defermentEndDate) },
    { label: 'Номинальная процентая ставка', value: contract?.interestForTranche || '-' },
    { label: 'Срок займа', value: contract?.trancheCount || '-' },
    { label: 'Штраф на ОС', value: `${contract?.penaltyOsOutstandingAmount?.toString()?.thousandSeparator() || 0} ₸` },
    { label: 'Сумма переведенных оплат', value: contract?.paymentsAmount || '-' },
    { label: 'Кол-во проведенных оплат ', value: contract?.paymentsNumber || '-' },
    { label: 'Количество оставшихся оплат', value: contract?.outstandingPaymentsNumber || '-' },
    {
      label: 'Сумма оставшихся оплат',
      value: `${contract?.outstandingPaymentsAmount?.toString()?.thousandSeparator() || 0} ₸`
    },
    {
      label: 'Штраф на процент',
      value: `${contract?.penaltyInterestOutstandingAmount?.toString()?.thousandSeparator() || 0} ₸`
    },
    { label: 'Дата завершения займа', value: getValidDate(contract?.repaymentPlanDate) },
    { label: 'Дата последнего погашения', value: getValidDate(contract?.lastPaymentDate) },
    {
      label: 'Наличие обеспечения и информации',
      value: contract?.isAvailableCollateralAndInformation || '-'
    },
    { label: 'Кол-во дней просрочки (по статусу)', value: contract?.statusOverdueDays || '-' },
    {
      label: 'Отсроченные проценты',
      value: `${contract?.deferredInterestOutstandingAmount?.toString()?.thousandSeparator() || 0} ₸`
    },
    {
      label: 'Отсроченные штрафы',
      value: `${contract?.deferredPenaltyOutstandingAmount?.toString()?.thousandSeparator() || 0} ₸`
    },
    { label: 'Кол-во дней просрочки (фактическое)', value: contract?.factOverdueDays || '-' },
    { label: 'Кол-во просроченных платежей', value: contract?.numberOverduePayments || '-' }
  ]
}
